export type Occupation = '예비 사업자' | '태양광 발전 사업자' | '시공사/시행사' | '제조사' | 'etc';

export const occupationList: { label: string; value: Occupation }[] = [
	{
		label: '예비 사업자',
		value: '예비 사업자',
	},
	{
		label: '태양광 발전 사업자',
		value: '태양광 발전 사업자',
	},
	{
		label: '시공사/시행사',
		value: '시공사/시행사',
	},
	{
		label: '제조사',
		value: '제조사',
	},
	{
		label: '기타(직접입력)',
		value: 'etc',
	},
];
